module.exports = __webpack_public_path__ + "img/cosplay-logo.ba03086e.png";